import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';

import { Switch } from 'bundles/cds-labs/components';

export const STATUS = {
  On: 'on',
  Off: 'off',
} as const;

export type StatusEnum = 'on' | 'off';

type Props = {
  defaultStatus?: StatusEnum;
  value?: StatusEnum;
  onToggle: (newStatus: StatusEnum) => void;
  disableToggle?: boolean;
  ariaLabel?: string;

  // tech-debt: remove these unused props
  hideStatusText?: boolean;
  onColor?: string;
  offColor?: string;
  onLabel?: string;
  offLabel?: string;
  toggleHandleColor?: string;
};

const ToggleSwitch = ({ value, defaultStatus, onToggle, disableToggle, ariaLabel }: Props) => {
  const [status, setStatus] = useState<StatusEnum | undefined>(value || defaultStatus);

  useEffect(() => {
    if (value != null && value !== status) {
      setStatus(value);
    }
  }, [value, status]);

  const handleToggle = useCallback<(...args: $TSFixMe[]) => $TSFixMe>(
    (isSelected: boolean) => {
      const newStatus = isSelected ? STATUS.On : STATUS.Off;
      setStatus(newStatus);
      onToggle(newStatus);
    },
    [onToggle]
  );

  return (
    <Switch
      aria-label={ariaLabel}
      selected={status === STATUS.On}
      onToggle={handleToggle}
      disabled={disableToggle}
      className="rc-ToggleSwitch"
    />
  );
};

ToggleSwitch.getStatus = () => STATUS;

export default ToggleSwitch;
